import React from 'react';
import styled from 'styled-components';
import { PrimaryButton } from '../../../shared/ui/Inputs';
import { ErrorMessage } from '../../../shared/messages/messages';
import { BoldTextColor, PrimaryTextColor, GreenAlert } from '../../../app/theme/tokens/colors';

const CardWrapper = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 40px 40px 32px;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
  max-width: 480px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const LogoLogin = styled.div`
  width: 260px;
  height: 90px;
  margin: 0 auto 16px auto;
  background-image: url(/icones/logo-color.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
`;

const Title = styled.p`
  color: ${BoldTextColor};
  font-size: 22px;
  text-align: center;
  margin-bottom: 4px;
`;

const Subtitle = styled.p`
  color: ${PrimaryTextColor};
  font-size: 16px;
  text-align: center;
  margin-bottom: 24px;
`;

const InfoBox = styled.div`
  background: ${GreenAlert};
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 24px;
  color: ${PrimaryTextColor};
  text-align: center;
  font-size: 15px;
`;

export const RecoveryEmailSentCard: React.FC<{ email: string; onBack: () => void }> = ({ email, onBack }) => {
    return (
        <CardWrapper>
            <LogoLogin />

            <Title>E-mail enviado!</Title>
            <Subtitle>Verifique sua caixa de entrada</Subtitle>

            <InfoBox>
                Enviamos um link de redefinição de senha para: <b>{email}</b>
                <br />
                Caso não encontre, verifique sua caixa de spam.
            </InfoBox>

            <PrimaryButton onClick={onBack}>Voltar ao Login</PrimaryButton>
        </CardWrapper>
    );
};
